import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const ResearchRequestHypothesisEvidenceType = z.enum([
  'supporting',
  'negating',
  'contextual',
]);

export type ResearchRequestHypothesisEvidenceType = z.infer<
  typeof ResearchRequestHypothesisEvidenceType
>;

export const ResearchRequestHypothesisEvidenceSchema = z.object({
  researchRequestHypothesisEvidenceId: PrimaryKeySchema,
  researchRequestHypothesisId: PrimaryKeySchema,
  researchRequestEvidenceId: PrimaryKeySchema,
  evidenceType: ResearchRequestHypothesisEvidenceType,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ResearchRequestHypothesisEvidence = z.infer<
  typeof ResearchRequestHypothesisEvidenceSchema
>;

export const ResearchRequestHypothesisEvidencesSchema = z.array(
  ResearchRequestHypothesisEvidenceSchema,
);

export type ResearchRequestHypothesisEvidences = z.infer<
  typeof ResearchRequestHypothesisEvidencesSchema
>;

export const ResearchRequestHypothesisEvidenceQuerySchema = z.object({
  researchRequestHypothesisIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
  researchRequestEvidenceIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
  researchRequestHypothesisEvidenceIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
});

export type ResearchRequestHypothesisEvidenceQuery = z.infer<
  typeof ResearchRequestHypothesisEvidenceQuerySchema
>;

export const CreateResearchRequestHypothesisEvidenceSchema =
  ResearchRequestHypothesisEvidenceSchema.pick({
    researchRequestHypothesisId: true,
    researchRequestEvidenceId: true,
    evidenceType: true,
  });

export type CreateResearchRequestHypothesisEvidence = z.infer<
  typeof CreateResearchRequestHypothesisEvidenceSchema
>;
